// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContactsOutlinedSvg from "@fishx/icons-svg/es/asn/ContactsOutlined";
import FishxIcon from '../components/FishxIcon';

var ContactsOutlined = function ContactsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContactsOutlinedSvg
  }));
};

ContactsOutlined.displayName = 'ContactsOutlined';
export default React.forwardRef(ContactsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ContactsOutlined.js
// module id = 2312
// module chunks = 0